export default function Section2() {
  return (
    <div className="w-full Section2">
      <div className="w-full section2-container">
        <div className="mx-auto w-[90%] md:w-[61%] text-center">
          <h1 className="mt-[40px] text-[24px] leading-[29px] md:text-[34px] font-bold md:leading-[41px] text-[#151515]">
            Introduction
          </h1>
          <p className="leading-[20px] text-[#373737] text-base font-open">
            WooCommerce is a robust ecommerce extension for WordPress, allowing
            companies to easily and beautifully promote and sell products
            online. We provide scalable, high-performance, tailor-fit custom
            WooCommerce development solutions to brands and merchants ready to
            scale their web presence. Our team of e-commerce veterans is capable
            of delivering WooCommerce projects from mild to wild while meeting
            your expectations, timeline, and budget.
          </p>
        </div>
      </div>
      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
